<!--
 * @Author: your name
 * @Date: 2021-06-01 10:29:25
 * @LastEditTime: 2025-08-12 11:05:34
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\MediaItem.vue
-->
<template>
  <div class="media-item" ref="mediaBox">
    <div class="media-img" ref="mediaComponents">
      <img v-if="media.damaged === 0" class="m-img" style="object-fit: contain;" :src="media.ref_thumb_url" alt />
      <img v-else class="m-img" src="@imgpub/damaged.png" alt />
      <span class="m-time">{{
        media.type == 1 ? msFormatting(media.ref_time) : ""
      }}</span>

      <el-tooltip effect="dark" :content="$t('nemi04')" placement="top-start">
        <img class="bindnum" v-if="media.bindnum > 0" src="@imgpub/icon_yinyong.png" alt />
      </el-tooltip>

      <el-tooltip effect="dark" :content="[$t('nemi01'), $t('nemi02'), $t('nemi03')][media.material_state]"
        placement="top-start">
        <img class="check" :src="imageRequire(media.material_state)" alt />
      </el-tooltip>

      <div class="describe" v-if="media.describe">{{ media.describe }}</div>
      <div class="m-select" :class="{ 'm-select-a': mediaChecked }">
        <el-checkbox v-model="mediaChecked" @change="checkboxChange"></el-checkbox>
      </div>
      <ul class="f-menu-list flex-d-a-c" :style="mPoint" v-show="isMenuList">
        <li class="f-m-l-item" @click="handleFile('move')">
          {{ $t("explorer.move") }}
        </li>
        <!-- <li class="f-m-l-item" @click="handleFile('share')">分享</li> -->
        <li class="f-m-l-item" v-if="media.describe" @click="handleFile('edit')">
          {{ $t("ctcicc7") }}
        </li>
        <li class="f-m-l-item" @click="handleFile('copy')">
          {{ $t("explorer.copy") }}
        </li>
        <li class="f-m-l-item" @click="handleFile('del')">
          {{ $t("explorer.delete") }}
        </li>
      </ul>
      <!-- <div class="mask-layer" :title="media.describe"></div> -->
    </div>
    <div class="media-title ellipsis-1" :title="`${media.name}.${media.ref_ext}`">
      {{ `${media.name}.${media.ref_ext}` }}
    </div>
    <div class="media-title-r ellipsis-1">{{ media.ref_wh }}</div>
  </div>
</template>


<script>

import { msFormatting } from "@/assets/scripts/dateFormatting.js";

export default {
  name: 'MediaItem',
  props: {
    media: {
      type: Object,
      default: () => { }
    },
    isSelected: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      msFormatting: msFormatting,
      mediaChecked: false,
      isMenuList: false,
      mousePoint: {
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      }
    }
  },
  created() {
    this.mediaChecked = this.isSelected;
  },
  mounted() {
    this.$refs.mediaComponents.oncontextmenu = (e) => {
      e.preventDefault();
    };
    this.setOnMouseRight();
  },
  methods: {

    imageRequire(type) {
      switch (type) {
        case 0: return require("@/assets/images/program/unreviewed.png");
        case 1: return require("@/assets/images/program/refused.png");
        case 2: return require("@/assets/images/program/pass.png");
        default:
          break;
      }
    },
    // msFormatting(time) {
    //   let ms = parseInt(time);
    //   let H = Math.floor(ms / 1000 / 60 / 60);
    //   let M = Math.floor(ms / 1000 / 60) % 60;
    //   let S = Math.floor(ms / 1000) % 60;
    //   // let MS = ms % 1000;
    //   // return `${this.formatting(H)}:${this.formatting(M)}:${this.formatting(S)}:${this.formatting(MS, 3)}`;

    //   return `${this.formatting(H)}:${this.formatting(M)}:${this.formatting(S)}`;
    // },
    formatting(time, len = 2) {
      let strTime = time + '';
      while (strTime.length < len) {
        strTime = '0' + strTime
      }
      return strTime;
    },
    setOnMouseRight() {
      this.$refs.mediaComponents.onmousedown = (e) => {
        if (e.button == 2) {
          // alert("你点了右键");
          this.mousePoint.x = e.offsetX;
          this.mousePoint.y = e.offsetY;
          this.mousePoint.w = e.target.offsetWidth;
          this.mousePoint.h = e.target.offsetHeight;
          this.isMenuList = true;
          // console.log(e);
        } else if (e.button == 0) {
          // alert("你点了左键");
          // console.log(e)
        } else if (e.button == 1) {
          // alert("你点了滚轮");
          // console.log(e)
        }
      }
      this.$refs.mediaBox.onmouseleave = () => {
        // e.stopPropagation();
        this.isMenuList = false;
        // console.log(e);
      }
    },
    handleFile(type) {
      switch (type) {
        case "move":
          this.$emit("setMediaMoveId", this.media.id, "move");
          break;
        case "share":
          break;
        case "copy":
          this.$emit("setMediaMoveId", this.media.id, "copy");
          break;
        case "del":
          this.$emit("setDeleteMedia", this.media.id);
          break;
        case "edit":
          this.$emit("setDescribe", this.media.id, this.media.describe);
          break;
        default:
          break;
      }
    },
    checkboxChange(val) {
      this.$emit("setSelectMedia", val, this.media.id);
    }
  },
  watch: {
    isSelected: {
      handler(nVal) {
        this.mediaChecked = nVal;
      }
    }
  },
  computed: {
    mPoint() {
      return `
        left: ${(this.mousePoint.x + 60) > this.mousePoint.w ? (this.mousePoint.w - 62) : this.mousePoint.x}px; 
        top: ${(this.mousePoint.y + 90) > (this.mousePoint.h + 38) ? (this.mousePoint.y - 50) : this.mousePoint.y}px;`
    }
  }
}
</script>

<style lang="scss" scoped>
.media-item {
  position: relative;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;

  .media-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 56%;
    position: relative;
    background: #F4F4F5;

    .m-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      user-select: none;
    }

    .m-time {
      position: absolute;
      right: 0px;
      bottom: 0px;
      color: #ccc;
    }

    .bindnum {
      width: 20px;
      position: absolute;
      right: 0px;
      top: 0px;
      background: #fff;
      border-radius: 10px;
    }

    .check {
      width: 20px;
      position: absolute;
      right: 24px;
      top: 0px;
      // background: #fff;
      border-radius: 10px;
    }

    .describe {
      position: absolute;
      bottom: 0px;
      height: 32px;
      overflow: hidden;
      font-size: 16px;
      color: #fff;
      // pointer-events: none;
    }

    .mask-layer {
      position: absolute;
      top: 0px;
      width: 100%;
      height: 100%;
    }

    .m-select {
      position: absolute;
      left: 2px;
      top: 0px;
      opacity: 0;
    }

    .m-select-a {
      opacity: 1;
    }

    .f-menu-list {
      position: absolute;
      // left: 50%;
      // top: 50%;
      // transform: translate(-30%, -30%);
      z-index: 999;
      width: 60px;
      height: 90px;
      background-color: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;

      .f-m-l-item {
        width: 100%;
        text-align: center;
      }

      .f-m-l-item:hover {
        background-color: #edfbff;
        color: var(--theme-color-customized-1);
      }
    }
  }

  .media-img:hover .m-select {
    opacity: 1;
  }

  .media-img:hover {
    opacity: 0.6;
  }

  .media-title {
    width: calc(100% - 8px);
    line-height: 24px;
    background-color: #eefbff;
    font-size: 16px;
    padding: 0px 4px;
    user-select: none;
  }

  .media-title-r {
    width: calc(100% - 8px);
    line-height: 18px;
    font-size: 14px;
    background-color: #eefbff;
    padding: 0px 4px;
    user-select: none;
  }
}
</style>